export let state = {
    deviceModels: [],
    deviceProtocols: [],
    deviceCommandTypes: [],
    deviceCommandStates: [],
    deviceDataToCapture: [],
    channels: [],
    cameraPositionType: [],
    deviceHealthCheckTypes: [],
    videoStreamQualityTypes: [],
    speedUnitTypes: [],
    languages: [],
    licenses: [],
    roles: [],
    fuelTypes: [],
    vehicleTypes: [],
    eventTypes: [],
    eventCategories: [],
    eventClassifications: [],
    thresholdLevels: [],
    alarmPipelines: [],
    timelineBlockStatuses: [],
    timeZones: [],
    brandImageTypes: []
};
